import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "@utils/http";
import {
  FetchAvailableMaterialsParams,
  CreateMaterialReservationParams,
  CreateMaterialReservationResult,
  MaterialType,
  StandaloneMaterialReservation,
} from "../types";

export const fetchAvailableMaterials = createAsyncThunk(
  "material/fetchAvailable",
  async (params: FetchAvailableMaterialsParams, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams({
        SiteID: String(params.siteID),
        ResStart: params.resStart,
        ResStop: params.resStop,
        ...(params.clientTypeID != null
          ? { ClientTypeID: String(params.clientTypeID) }
          : {}),
        ...(params.requiresReservation != null
          ? { RequiresReservation: params.requiresReservation ? "1" : "0" }
          : {}),
      });
      const { data } = await http.get(
        `/customerportal/availableMaterials/?${query}`
      );
      return data.map(({
        MaterialTypeID,
        Name,
        Description,
        StorageLocation,
        MaxQuantity,
        AvailableQuantity,
        IsPaid,
        PricePerUnit,
        CanReserveStandalone,
        RequiresReservation,
        CheckupMinutes,
      }: any): MaterialType => ({
        materialTypeId: MaterialTypeID,
        name: Name,
        description: Description ?? null,
        storageLocation: StorageLocation,
        maxQuantity: MaxQuantity,
        availableQuantity: AvailableQuantity,
        isPaid: IsPaid,
        pricePerUnit: PricePerUnit ?? null,
        canReserveStandalone: CanReserveStandalone,
        requiresReservation: RequiresReservation,
        checkupMinutes: CheckupMinutes,
      }));
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createMaterialReservation = createAsyncThunk<CreateMaterialReservationResult, CreateMaterialReservationParams>(
  "material/createReservation",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await http.post(
        "/customerportal/materialReservation/",
        params
      );
      return data as unknown as CreateMaterialReservationResult;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const fetchMaterialReservations = createAsyncThunk<StandaloneMaterialReservation[]>(
  "material/fetchReservations",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await http.get("/customerportal/MaterialReservations/");
      return data.map(({
        MaterialReservationID,
        MaterialTypeID,
        MaterialName,
        LinkedReservationID,
        QuantityReserved,
        ResStart,
        ResStop,
        ActualReturnedAt,
        IsPaid,
        PricePaid,
        Status,
        CreatedAt,
        MaterialItemID,
      }: any): StandaloneMaterialReservation => ({
        materialReservationID: MaterialReservationID,
        materialTypeID: MaterialTypeID,
        materialName: MaterialName,
        linkedReservationID: LinkedReservationID,
        quantityReserved: QuantityReserved,
        resStart: ResStart,
        resStop: ResStop,
        actualReturnedAt: ActualReturnedAt ?? null,
        isPaid: IsPaid,
        pricePaid: PricePaid,
        status: Status,
        createdAt: CreatedAt,
        materialItemID: MaterialItemID,
      }));
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const cancelMaterialReservation = createAsyncThunk(
  "material/cancelReservation",
  async (
    params: { materialReservationID: number; clientID: number },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await http.post(
        "/customerportal/cancelMaterialReservation/",
        params
      );
      return data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
